'use client';

import { GoogleAnalytics } from '@next/third-parties/google';
import ClarityTracker from './ClarityTracker';
import HubSpotTracker from './HubSpotTracker';

export default function Tracking() {
  const GTM = process.env.NEXT_PUBLIC_GTM_ID || '';
  return (
    <>
      <HubSpotTracker />
      <GoogleAnalytics gaId={GTM} />
      <ClarityTracker />
    </>
  );
}
